import { Injectable } from '@angular/core';
import { AccountHttpService } from '@services/http/account/account-http.service';
import { firstValueFrom } from 'rxjs';
import { ISendPasswordResetCode } from '@models/data/account/form-data/ISendPasswordResetCode';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private httpService: AccountHttpService) {}

  public async sendResetPasswordCode(
    formData: ISendPasswordResetCode
  ): Promise<void> {
    await firstValueFrom(
      await this.httpService.sendResetPasswordCode(formData)
    );
  }
}
